// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICipStatusMultiEmployersSummaryRecordDto
 */
export interface ICipStatusMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {number}
     * @memberof ICipStatusMultiEmployersSummaryRecordDto
     */
    num_pending?: number;
    /**
     * 
     * @type {number}
     * @memberof ICipStatusMultiEmployersSummaryRecordDto
     */
    num_passed?: number;
    /**
     * 
     * @type {number}
     * @memberof ICipStatusMultiEmployersSummaryRecordDto
     */
    num_failed?: number;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusMultiEmployersSummaryRecordDto
     */
    percent_passed?: string;
}

/**
 * Check if a given object implements the ICipStatusMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfICipStatusMultiEmployersSummaryRecordDto(value: object): value is ICipStatusMultiEmployersSummaryRecordDto {
    return true;
}

export function ICipStatusMultiEmployersSummaryRecordDtoFromJSON(json: any): ICipStatusMultiEmployersSummaryRecordDto {
    return ICipStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function ICipStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICipStatusMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'num_pending': json['num_pending'] == null ? undefined : json['num_pending'],
        'num_passed': json['num_passed'] == null ? undefined : json['num_passed'],
        'num_failed': json['num_failed'] == null ? undefined : json['num_failed'],
        'percent_passed': json['percent_passed'] == null ? undefined : json['percent_passed'],
    };
}

export function ICipStatusMultiEmployersSummaryRecordDtoToJSON(json: any): ICipStatusMultiEmployersSummaryRecordDto {
    return ICipStatusMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function ICipStatusMultiEmployersSummaryRecordDtoToJSONTyped(value?: ICipStatusMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'num_pending': value['num_pending'],
        'num_passed': value['num_passed'],
        'num_failed': value['num_failed'],
        'percent_passed': value['percent_passed'],
    };
}

